module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_wrap"
  }, [_c('div', {
    staticClass: "m_header",
    on: {
      "click": function($event) {}
    }
  }, [_c('a', {
    staticClass: "goback",
    attrs: {
      "href": "#/app/newSong"
    }
  }, [_vm._v("<返回")]), _vm._v(" 账号注册\n            "), _c('a', {
    staticClass: "m_header_refresh",
    attrs: {
      "href": "javascript:;"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "register-form",
      "name": "pop-form-login",
      "method": "post"
    }
  }, [_c('form', {
    attrs: {
      "id": "uploadForm"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "deviceinfo",
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        _vm.doUpload()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "m_label"
  }, [_c('img', {
    staticClass: "headpic",
    attrs: {
      "src": require("../../static/logo.png")
    },
    on: {
      "click": function($event) {
        _vm.uploadImg()
      }
    },
    model: {
      value: (_vm.imgurl),
      callback: function($$v) {
        _vm.imgurl = $$v
      },
      expression: "imgurl"
    }
  })])]), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "注册帐号",
      "hintText": "请输入注册手机号码",
      "labelFloat": ""
    },
    model: {
      value: (_vm.telephone),
      callback: function($$v) {
        _vm.telephone = $$v
      },
      expression: "telephone"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "昵称",
      "hintText": "请输入昵称",
      "labelFloat": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "输入密码",
      "hintText": "请输入6-20位密码",
      "type": "password",
      "labelFloat": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "确认密码",
      "hintText": "再次确认密码",
      "type": "password",
      "labelFloat": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "geetest"
  }, [_c('div', {
    staticClass: "gt_bg"
  }), _vm._v(" "), _c('div', [_c('mu-raised-button', {
    staticClass: "submit-btn demo-raised-button",
    attrs: {
      "label": "确认注册",
      "id": "reg-btn",
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.gotoRegister()
      }
    }
  })], 1)])], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "小提示"
    },
    on: {
      "close": _vm.close
    }
  }, [_vm._v("\n        " + _vm._s(_vm.openCon) + "\n        "), _c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51821104"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xregister.vue
// module id = 258
// module chunks = 0